function fallbackCopyToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let successful = false;
  try {
    successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('unable to copy');
    }
  } catch (err) {
    window.prompt('pleaseCopyThisText', text);
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
  // eslint-disable-next-line prefer-promise-reject-errors
  return successful ? Promise.resolve() : Promise.reject('NotAllowedError');
}

export default function copyToClipboard(text: string) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)

  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).catch((err) => {
      console.error(err || 'The request is not allowed');
      fallbackCopyToClipboard(text);
    });
  }

  return fallbackCopyToClipboard(text);
}
